<ng-container *ngIf="!loading; else loadingContent">
  <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
    <div>{{ fileName }}</div>
    <button type="button" mat-icon-button (click)="close(false)" tabindex="-1">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>

  <ng-container [ngSwitch]="previewType">
    <ng-container *ngSwitchCase="'pdf'">
      <div class="card w-full h-[70vh]">
        <object [data]="url" type="application/pdf" class="w-full h-full">
          <iframe class="h-full w-full" [src]="url">
            <p>This browser does not support PDF!</p>
          </iframe>
        </object>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'excel'">
      <div class="card w-full h-[70vh] overflow-hidden flex flex-col">
        <mat-tab-group *ngIf="excelSheets.length > 1; else singleSheet" class="flex-1 min-h-0">
          <mat-tab *ngFor="let sheet of excelSheets" [label]="sheet.name">
            <div class="excel-sheet-content" [innerHTML]="sheet.html"></div>
          </mat-tab>
        </mat-tab-group>
        <ng-template #singleSheet>
          <div class="excel-sheet-content flex-1 min-h-0" [innerHTML]="excelSheets[0]?.html"></div>
        </ng-template>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'image'">
      <div class="card w-full h-[70vh] flex justify-center items-center">
        <img [src]="url" alt="Image preview" class="max-w-full max-h-full object-contain" />
      </div>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <div class="card w-full h-[70vh] flex flex-col justify-center items-center gap-4">
        <p class="text-base text-center px-4">La prévisualisation de ce type de fichier n'est pas disponible.</p>
        <button mat-raised-button color="primary" (click)="download()">
          <mat-icon [icIcon]="icDownload" class="mr-2"></mat-icon>
          Télécharger le fichier
        </button>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #loadingContent>
  <div class="card h-64 mt-6">
    <div class="flex justify-center items-center h-full">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  </div>
</ng-template>
